module.exports = __webpack_public_path__ + "static/img/top.6a8df88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/6/top.jpg
// module id = qdrM
// module chunks = 27